<template>
    <div class="publishTEMU">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>基本信息</span>
                </div>
                <el-form-item label="店铺账号：" prop="storeAccount">
                    <el-select v-model="ruleForm.storeAccount" placeholder="请选择店铺账号"
                        @change="handleChange('storeAccount', $event)">
                        <el-option :label="item.shop_name ? item.shop_name : item.shop_id"
                            :value="item.shop_id + '+-+' + item.shop_site" v-for="(item, index) in storeAccountOptions"
                            :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="经营站点：" prop="site">
                    <el-select v-model="ruleForm.site" placeholder="请选择经营站点">
                        <el-option :label="item.shop_name" :value="item.shop_id" v-for="(item, index) in siteOptions"
                            :key="index"></el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="选择仓库：" prop="warehouseId">
                    <el-select v-model="ruleForm.warehouseId" placeholder="请选择仓库">
                        <el-option v-for="item in warehouseOptions" :key="item.warehouseId" :label="item.warehouseName"
                            :value="item.warehouseId">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="产品分类：" prop="productClassify">
                    <el-cascader ref="nodeName" v-model="ruleForm.productClassify" :options="options"
                        :props="{ 'multiple': false, 'lazy': true, 'lazyLoad': fetchData }"
                        @change="handleChange('productClassify', $event)" :loading="loading"></el-cascader>
                </el-form-item>
                <el-form-item label="产品属性：" prop="productAttribute">
                    <div class="productAttribute">
                        <el-form-item :label="item.name + '：'" :rules="{
                            required: item.required,
                            message: item.valueRule == 1 ? '数值之和等于100' : '不能为空',
                            trigger: 'blur',
                        }" style="margin-bottom: 10px;" v-for="(item, index) in properties" :key="index"
                            v-if="(!item.isSale || (item.isSale && (item.name != '颜色' && item.name != '尺码'))) && item.isParentStatus">
                            <!-- {{ item.controlType }}
                            {{ item.chooseMaxNum }} -->
                            <el-input v-model="item.propValue" clearable v-if="item.controlType == 0">
                            </el-input>
                            <el-checkbox-group v-model="item.propValueArr" :min="1" :max="item.chooseMaxNum"
                                v-if="item.controlType == 1 && item.chooseMaxNum > 1">
                                <el-checkbox v-for="chilrenItem in item.values"
                                    :label="chilrenItem.vid + '+-+' + chilrenItem.value" :key="chilrenItem.vid">{{
                                        chilrenItem.value }}</el-checkbox>
                            </el-checkbox-group>
                            <el-select v-model="item.propValue" clearable placeholder="请选择"
                                v-if="item.controlType == 1 && item.chooseMaxNum == 1">
                                <el-option v-for="chilrenItem in item.values" :key="chilrenItem.vid"
                                    :label="chilrenItem.value" :value="chilrenItem.vid + '+-+' + chilrenItem.value">
                                </el-option>
                            </el-select>
                            <div v-if="item.controlType == 3 && item.chooseMaxNum > 1">
                                <el-checkbox-group v-model="item.propValueArr" :min="1" :max="item.chooseMaxNum">
                                    <el-checkbox v-for="chilrenItem in item.values"
                                        :label="chilrenItem.vid + '+-+' + chilrenItem.value" :key="chilrenItem.vid">{{
                                            chilrenItem.value }}</el-checkbox>
                                </el-checkbox-group>
                                <el-input v-model="item.propValue" clearable>
                                </el-input>
                            </div>
                            <el-date-picker v-model="item.propValue" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期" v-if="item.controlType == 5">
                            </el-date-picker>
                            <el-date-picker v-model="item.propValue" type="daterange" value-format="yyyy-MM-dd"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                v-if="item.controlType == 6">
                            </el-date-picker>
                            <el-date-picker v-model="item.propValue" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期" v-if="item.controlType == 7">
                            </el-date-picker>
                            <el-date-picker v-model="item.propValue" type="daterange" value-format="yyyy-MM"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                v-if="item.controlType == 8">
                            </el-date-picker>
                            <div v-if="item.controlType == 16">
                                <div style="display: flex;">
                                    <el-select v-model="item.propValue" clearable placeholder="请选择">
                                        <el-option v-for="chilrenItem in item.values" :key="chilrenItem.vid"
                                            :label="chilrenItem.value" :value="chilrenItem.vid + '+-+' + chilrenItem.value">
                                        </el-option>
                                    </el-select>
                                    <el-input v-model="item.numberInputValue" type="number" :min="item.minValue"
                                        :max="item.maxValue" clearable style="width: 200px;margin: 0 10px;">
                                    </el-input>
                                    <el-button>{{ item.valueUnit }}</el-button>
                                    <i class="el-icon-plus" @click="addAttribute(item)"
                                        style="margin-top: 10px;margin-left: 20px; font-size: 20px;color: #428bca;cursor: pointer;"></i>
                                </div>
                                <div style="display: flex;margin-top: 10px;" v-if="item.childrenBox"
                                    v-for="(itemBox, itemBoxIndex) in item.childrenBox" :key="itemBoxIndex">
                                    <el-select v-model="itemBox.propValue" clearable placeholder="请选择">
                                        <el-option v-for="chilrenItem in itemBox.values" :key="chilrenItem.vid"
                                            :label="chilrenItem.value" :value="chilrenItem.vid + '+-+' + chilrenItem.value">
                                        </el-option>
                                    </el-select>
                                    <el-input v-model="itemBox.numberInputValue" type="number" :min="itemBox.minValue"
                                        :max="itemBox.maxValue" clearable style="width: 200px;margin: 0 10px;">
                                    </el-input>
                                    <el-button>{{ itemBox.valueUnit }}</el-button>
                                    <i class="el-icon-plus" @click="addAttribute(item)"
                                        style="margin-top: 10px;margin-left: 20px; font-size: 20px;color: #428bca;cursor: pointer;"></i>
                                    <i class="el-icon-minus" @click="delAttribute(item, itemBoxIndex)"
                                        style="margin-top: 10px;margin-left: 20px; font-size: 20px;color: #ec4339;cursor: pointer;"></i>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                </el-form-item>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>产品信息</span>
                </div>
                <el-form-item label="产品标题：" prop="productTitle">
                    <div class="flex">
                        <el-input v-model="ruleForm.productTitle" :maxlength="maxlength" clearable>
                            <template slot="append">
                                <el-tooltip class="item" effect="dark" content="把单词首字母转为大写（点击生效）" placement="top">
                                    <i class="el-icon-thumb" @click="convert('productTitle')"></i>
                                </el-tooltip>
                            </template>
                        </el-input>
                        <span class="smallTips">{{ ruleForm.productTitle ? ruleForm.productTitle.length : 0
                        }}/{{ maxlength }}</span>
                    </div>
                </el-form-item>
                <el-form-item label="英文标题：" prop="productTitleEN">
                    <div class="flex">
                        <el-input v-model="ruleForm.productTitleEN" :maxlength="maxlength" clearable>
                            <template slot="append">
                                <el-tooltip class="item" effect="dark" content="把单词首字母转为大写（点击生效）" placement="top">
                                    <i class="el-icon-thumb" @click="convert('productTitleEN')"></i>
                                </el-tooltip>
                            </template>
                        </el-input>
                        <span class="smallTips">{{ ruleForm.productTitleEN ? ruleForm.productTitleEN.length : 0
                        }}/{{ maxlength }}</span>
                    </div>
                </el-form-item>
                <!-- <el-form-item label="产品货号：" prop="productCode">
                    <div class="flex">
                        <el-input v-model="ruleForm.productCode" @input="verify('productCode')"
                            placeholder="产品货号不能包含中文和中文符号" clearable>
                        </el-input>
                    </div>
                </el-form-item> -->
                <el-form-item label="产地：" prop="region2Id">
                    <el-select v-model="ruleForm.region1ShortName" placeholder="请选择">
                        <el-option label="中国" :value="'CN'"></el-option>
                    </el-select>
                    <el-select v-model="ruleForm.region2Id" placeholder="请选择" style="margin-left: 10px;">
                        <el-option label="北京市" :value="43000000000002"></el-option>
                        <el-option label="安徽省" :value="43000000000003"></el-option>
                        <el-option label="福建省" :value="43000000000004"></el-option>
                        <el-option label="甘肃省" :value="43000000000005"></el-option>
                        <el-option label="广东省" :value="43000000000006"></el-option>
                        <el-option label="广西壮族自治区" :value="43000000000007"></el-option>
                        <el-option label="贵州省" :value="43000000000008"></el-option>
                        <el-option label="海南省" :value="43000000000009"></el-option>
                        <el-option label="河北省" :value="43000000000010"></el-option>
                        <el-option label="河南省" :value="43000000000011"></el-option>
                        <el-option label="黑龙江省" :value="43000000000012"></el-option>
                        <el-option label="湖北省" :value="43000000000013"></el-option>
                        <el-option label="湖南省" :value="43000000000014"></el-option>
                        <el-option label="吉林省" :value="43000000000015"></el-option>
                        <el-option label="江苏省" :value="43000000000016"></el-option>
                        <el-option label="江西省" :value="43000000000017"></el-option>
                        <el-option label="辽宁省" :value="43000000000018"></el-option>
                        <el-option label="内蒙古自治区" :value="43000000000019"></el-option>
                        <el-option label="宁夏回族自治区" :value="43000000000020"></el-option>
                        <el-option label="青海省" :value="43000000000021"></el-option>
                        <el-option label="山东省" :value="43000000000022"></el-option>
                        <el-option label="山西省" :value="43000000000023"></el-option>
                        <el-option label="陕西省" :value="43000000000024"></el-option>
                        <el-option label="上海市" :value="43000000000025"></el-option>
                        <el-option label="四川省" :value="43000000000026"></el-option>
                        <el-option label="天津市" :value="43000000000027"></el-option>
                        <el-option label="西藏自治区" :value="43000000000028"></el-option>
                        <el-option label="新疆维吾尔自治区" :value="43000000000029"></el-option>
                        <el-option label="云南省" :value="43000000000030"></el-option>
                        <el-option label="浙江省" :value="43000000000031"></el-option>
                        <el-option label="重庆市" :value="43000000000032"></el-option>
                        <el-option label="香港特别行政区" :value="43000000000033"></el-option>
                        <el-option label="澳门特别行政区" :value="43000000000034"></el-option>
                        <el-option label="台湾省" :value="43000000000035"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="站外产品链接：" prop="links">
                    <div class="flex">
                        <el-input v-model="ruleForm.links" clearable>
                        </el-input>
                    </div>
                </el-form-item>
                <el-form-item label="敏感属性：" prop="sensitiveSwitch">
                    <div class="flex" style="height: 40px;align-items: center;">
                        <el-radio v-model="ruleForm.sensitiveSwitch" :label="1">是</el-radio>
                        <el-radio v-model="ruleForm.sensitiveSwitch" :label="0">否</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="敏感类型：" prop="sensitiveType" v-if="ruleForm.sensitiveSwitch == 1">
                    <div class="flex">
                        <el-checkbox-group v-model="ruleForm.sensitiveType">
                            <el-checkbox :label="110001">纯电</el-checkbox>
                            <el-checkbox :label="120001">内电</el-checkbox>
                            <el-checkbox :label="130001">磁性</el-checkbox>
                            <el-checkbox :label="140001">液体</el-checkbox>
                            <el-checkbox :label="150001">粉末</el-checkbox>
                            <el-checkbox :label="160001">膏体</el-checkbox>
                            <el-checkbox :label="170001">刀具</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <div class="flex" v-if="ruleForm.sensitiveSwitch == 1">
                    <el-form-item label="电量：" prop="productSkuSensitiveLimitReq"
                        v-if="ruleForm.sensitiveType.includes(110001) || ruleForm.sensitiveType.includes(120001)">
                        <el-input type="number" v-model="ruleForm.productSkuSensitiveLimitReq.maxBatteryCapacity">
                            <template slot="append">wh</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="容量：" prop="productSkuSensitiveLimitReq"
                        v-if="ruleForm.sensitiveType.includes(140001)">
                        <el-input type="number" v-model="ruleForm.productSkuSensitiveLimitReq.maxLiquidCapacity">
                            <template slot="append">ml</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="长度：" prop="productSkuSensitiveLimitReq"
                        v-if="ruleForm.sensitiveType.includes(170001)">
                        <el-input type="number" v-model="ruleForm.productSkuSensitiveLimitReq.maxKnifeLength">
                            <template slot="append">cm</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="刀刃角度：" prop="productSkuSensitiveLimitReq"
                        v-if="ruleForm.sensitiveType.includes(170001)">
                        <el-input type="number" v-model="ruleForm.productSkuSensitiveLimitReq.knifeTipAngle.degrees">
                            <template slot="append">度</template>
                        </el-input>
                    </el-form-item>
                </div>
                <el-form-item label="定制产品：" prop="personalizationSwitch">
                    <div class="flex" style="height: 40px;align-items: center;">
                        <el-radio v-model="ruleForm.personalizationSwitch" :label="1">是</el-radio>
                        <el-radio v-model="ruleForm.personalizationSwitch" :label="0">否</el-radio>
                    </div>
                </el-form-item>
                <el-form-item label="产品轮播图：" prop="links">
                    <div>
                        <!-- <div style="border-bottom:1px solid #eee;padding-bottom:3px;">
                            <el-button size="mini" type="primary" @click="randomNum()">{{ $t('other.a290') }}</el-button>
                            <el-button size="mini" type="primary" @click="editorwaterMakr()">{{ $t('other.a291')
                            }}</el-button>
                            <el-button size="mini" type="primary" @click="replaceImg = true">{{ $t('other.a292')
                            }}</el-button>
                        </div>
                        <div style="font-size:12px;padding-top:10px;" @click="logImg()">{{ $t('other.a293') }}</div> -->

                        <div class="smallTips">1 点击图片拖动，即可调整图片顺序！</div>
                        <div class="smallTips">2 「产品轮播图最多选用10张，最少选用5张，已经选用了{{ ruleForm.images.length
                        }}张」，比例为1:1，不小于800*800，大小在2M以内</div>
                        <div style="display:flex;">
                            <draggable style="display:flex;" v-model="ruleForm.images" tag='ul' v-bind="dragOptions"
                                @change="logImg()" @start="ruleForm.drag = true" @end="ruleForm.drag = false">
                                <div class="imgBox" @mouseenter="activeIndex = index" @mouseleave="activeIndex = -1"
                                    v-for="(item, index ) in ruleForm.images" :key="index">
                                    <img style="width:100%" :src="item" />
                                    <span v-show="activeIndex == index" class="delBox">
                                        <div class="ingk">
                                            <!-- <i class="el-icon-edit" @click="editorImg(item.image, index)"></i> -->
                                            <i class="el-icon-delete" @click="ruleForm.images.splice(index, 1)"></i>
                                        </div>
                                    </span>
                                </div>

                            </draggable>

                            <el-upload v-if="ruleForm.images.length < 10" action="#" :show-file-list="false"
                                :http-request="uploadTEMU" :before-upload="beforeUpload">
                                <div class="imgBox">
                                    <div class="pomjg">
                                        <i class="el-icon-picture-outline"></i>
                                        <div style="font-size:12px; line-height: normal;">{{ $t('other.a294') }}</div>
                                    </div>
                                </div>
                            </el-upload>

                        </div>

                    </div>
                </el-form-item>
                <el-form-item label="产品素材图：" prop="links">
                    <div class="imgBox" @mouseenter="activeOneIndex = 1" @mouseleave="activeOneIndex = -1"
                        v-if="ruleForm.imagesOne != ''">
                        <img style="width:100%" :src="ruleForm.imagesOne" />
                        <span v-show="activeOneIndex == 1" class="delBox">
                            <div class="ingk">
                                <!-- <i class="el-icon-edit" @click="editorImg(item.image, index)"></i> -->
                                <i class="el-icon-delete" @click="ruleForm.imagesOne = ''"></i>
                            </div>
                        </span>
                    </div>
                    <el-upload v-if="ruleForm.imagesOne == ''" action="#" :show-file-list="false"
                        :http-request="uploadTEMUOne" :before-upload="beforeUpload">
                        <div class="imgBox">
                            <div class="pomjg">
                                <i class="el-icon-picture-outline"></i>
                                <div style="font-size:12px; line-height: normal;">{{ $t('other.a294') }}</div>
                            </div>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>包装信息</span>
                </div>
                <el-form-item label="外包装形状：" prop="packageShape">
                    <el-select v-model="ruleForm.packageShape" placeholder="请选择外包装形状">
                        <el-option label="不规则形状" :value="0"></el-option>
                        <el-option label="长方体" :value="1"></el-option>
                        <el-option label="圆柱体" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="外包装类型：" prop="packageType">
                    <el-select v-model="ruleForm.packageType" placeholder="请选择外包装类型">
                        <el-option label="硬包装" :value="0"></el-option>
                        <el-option label="软包装+硬物" :value="1"></el-option>
                        <el-option label="软包装+软物" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-card>
            <el-card class="box-card editorBox">
                <div slot="header" class="clearfix">
                    <span>产品描述</span>
                </div>
                <div class="DivHover"
                    style="width: 750px;max-height: 1000px;overflow: hidden;cursor: pointer;position: relative;"
                    @click="OpenProductDescribe" v-if="ruleForm.productDescribe.length > 0">
                    <div v-for="(item, index) in ruleForm.productDescribe" :key="index" style="width: 750px;padding: 20px;">
                        <div v-if="item.type == 'text'"
                            :style="`text-align:${item.contentList[0].textModuleDetails.align};font-size:${item.contentList[0].textModuleDetails.fontSize}px;background:${item.contentList[0].textModuleDetails.backgroundColor};color:${item.contentList[0].textModuleDetails.fontColor};`">
                            {{ item.contentList[0].text }}
                        </div>
                        <img class="img" :src="item.contentList[0].imgUrl" alt="" srcset="" width="100%" v-else>
                    </div>
                    <div class="DivHoverItem">点击设置产品描述模块(文字或图片)</div>
                </div>
                <!-- <quill-editor ref="myTextEditor" v-model="ruleForm.productDescribe" :options="editorOption"
                        style="height: 450px;"></quill-editor> -->
            </el-card>
            <el-card class="box-card editorBox" v-if="!isStatus">
                <div slot="header" class="clearfix">
                    <span>变种属性</span>
                </div>
                <div class="flex checkSpecBox">
                    <el-select v-model="parentSpecActive1" placeholder="请选择">
                        <el-option v-show="parentSpecActive2 != item.parentSpecId" v-for="item in parentSpec"
                            :key="item.parentSpecId" :label="item.parentSpecName"
                            :value="item.parentSpecId + '+-+' + item.parentSpecName">
                        </el-option>
                    </el-select>
                    <div class="checkSpecRight">
                        <div class="addSpec">
                            <el-checkbox-group v-model="itemSpec1">
                                <el-checkbox v-for="(item, index) in itemSpecChild1" :label="item.name" :key="index">
                                    <div v-if="!item.editStatus">
                                        {{ item.name }}<i @click="setEditStatus($event, 1, index, 'change')"
                                            style="margin-left: 10px;" class="el-icon-edit"></i>
                                    </div>
                                    <div class="flex" style="align-items: center;" v-else>
                                        <el-input size="small" v-model="item.editName" clearable>
                                        </el-input>
                                        <i style="margin-left: 10px;font-size: 20px;" class="el-icon-edit-outline"
                                            @click="setEditStatus($event, 1, index, 'edit')"></i>
                                        <i style="margin-left: 10px;font-size: 20px;" class="el-icon-close"
                                            @click="setEditStatus($event, 1, index, 'close')"></i>
                                    </div>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="flex">
                            <el-input v-model="addSpecName1" clearable>
                            </el-input>
                            <el-button type="primary" @click="addSpec('1')">添加</el-button>
                        </div>
                    </div>
                </div>

                <div class="flex checkSpecBox">
                    <el-select v-model="parentSpecActive2" placeholder="请选择">
                        <el-option v-show="parentSpecActive1 != item.parentSpecId" v-for="item in parentSpec"
                            :key="item.parentSpecId" :label="item.parentSpecName"
                            :value="item.parentSpecId + '+-+' + item.parentSpecName">
                        </el-option>
                    </el-select>
                    <div class="checkSpecRight">
                        <div class="addSpec">
                            <el-checkbox-group v-model="itemSpec2">
                                <el-checkbox v-for="(item, index) in itemSpecChild2" :label="item.name" :key="index">
                                    <div v-if="!item.editStatus">
                                        {{ item.name }}<i @click="setEditStatus($event, 2, index, 'change')"
                                            style="margin-left: 10px;" class="el-icon-edit"></i>
                                    </div>
                                    <div class="flex" style="align-items: center;" v-else>
                                        <el-input size="small" v-model="item.editName" clearable>
                                        </el-input>
                                        <i style="margin-left: 10px;font-size: 20px;" class="el-icon-edit-outline"
                                            @click="setEditStatus($event, 2, index, 'edit')"></i>
                                        <i style="margin-left: 10px;font-size: 20px;" class="el-icon-close"
                                            @click="setEditStatus($event, 2, index, 'close')"></i>
                                    </div>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="flex">
                            <el-input v-model="addSpecName2" clearable>
                            </el-input>
                            <el-button type="primary" @click="addSpec('2')">添加</el-button>
                        </div>
                    </div>
                </div>

            </el-card>
            <el-card class="box-card editorBox" v-else>
                <div slot="header" class="clearfix">
                    <span>变种属性</span>
                </div>
                <div class="flex checkSpecBox">
                    <div style="width: 80px;">
                        {{ parentSpecActive1.split('+-+')[1] }}
                    </div>
                    <div class="checkSpecRight">
                        <div class="addSpec">
                            <el-checkbox-group v-model="itemSpec1">
                                <el-checkbox v-for="item in itemSpecChild1" :label="item.specId + '+-+' + item.value"
                                    :key="item.name">{{
                                        item.value
                                    }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="flex">
                            <el-input v-model="addSpecName1" clearable>
                            </el-input>
                        </div>
                    </div>
                </div>

                <div class="flex checkSpecBox">
                    <div style="width: 80px;">
                        {{ parentSpecActive2.split('+-+')[1] }}
                    </div>
                    <div class="checkSpecRight">
                        <div class="addSpec">
                            <el-checkbox-group v-model="itemSpec2">
                                <el-checkbox v-for="item in itemSpecChild2" :label="item.specId + '+-+' + item.value"
                                    :key="item.name">{{
                                        item.value
                                    }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
                <div>尺码表：<el-button type="primary" @click="openSize">添加尺码表</el-button></div>
            </el-card>
            <el-card class="box-card editorBox">
                <div slot="header" class="clearfix">
                    <span>变种信息</span>
                </div>
                <div style="display: flex;margin-bottom: 10px;">
                    <div>选择仓库：</div>
                    <el-select v-model="warehouse" multiple collapse-tags style="margin-left: 20px;width: 400px;"
                        placeholder="请选择">
                        <el-option v-for="item in warehouseOptions" :key="item.warehouseId" :label="item.warehouseName"
                            :value="item.warehouseId + '+-+' + item.warehouseName">
                        </el-option>
                    </el-select>
                </div>
                <div class="ilnrg ppol">
                    <div class="yhgt">
                        <span class="yjbg"><el-input size="mini" style="width:150px" v-model="sellerSKU"
                                placeholder="sellerSku"></el-input></span>
                        <span class="yjbg"><el-input size="mini" style="width:150px" v-model="priceValue"
                                placeholder="price"></el-input></span>
                        <!-- <span class="yjbg"><el-input size="mini" style="width:150px" v-model="stock"
                                placeholder="stock"></el-input></span> -->
                        <span class="yjbg"><el-input size="mini" style="width:100px" v-model="long"
                                placeholder="long"></el-input></span>
                        <span class="yjbg"><el-input size="mini" style="width:100px" v-model="wide"
                                placeholder="wide"></el-input></span>
                        <span class="yjbg"><el-input size="mini" style="width:100px" v-model="tall"
                                placeholder="tall"></el-input></span>
                        <span class="yjbg"><el-input size="mini" style="width:100px" v-model="weight"
                                placeholder="weight"></el-input></span>
                        <span class="yjbg"><el-button size="mini" style="width:100px" @click="massSetVariation()"
                                type="info">{{ $t('other.a307') }}</el-button></span>
                    </div>
                    <div style="width:100%;" class="yhjv">
                        <el-table size="mini" border :data="specsArr" style="width: 100%">
                            <el-table-column prop="date" label="预览图" width="60">
                                <template slot-scope="props">
                                    <el-popover v-if="ruleForm.variations[props.$index].image" ref="popover1"
                                        placement="right" trigger="hover">
                                        <img style="width:200px;height:200px;"
                                            :src="ruleForm.variations[props.$index].image" alt="">
                                        <div slot="reference">
                                            <div class="ImgPox" @click="changePic(ruleForm.variations[props.$index], 1)">
                                                <img :src="ruleForm.variations[props.$index].image" alt="">
                                            </div>
                                        </div>
                                    </el-popover>
                                    <div v-else class="attImg" @click="changePic(ruleForm.variations[props.$index], 1)">
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" :label="parentSpecActive1.split('+-+')[1]"
                                v-if="itemSpec1.length > 0">
                                <template slot-scope="props">
                                    <div>
                                        {{ props.row.itemSpec1Value }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" :label="parentSpecActive2.split('+-+')[1]"
                                v-if="itemSpec2.length > 0">
                                <template slot-scope="props">
                                    <div>
                                        {{ props.row.itemSpec2Value }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" :label="item.warehouseName" v-for="(item, index) in warehouseName"
                                :key="item.warehouseId">
                                <template slot-scope="props">
                                    <el-input size="mini"
                                        v-model="ruleForm.variations[props.$index].warehouseStockQuantityReqs[index].targetStockAvailable"
                                        placeholder="">

                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" label="SKU">
                                <template slot-scope="props">
                                    <el-input size="mini" v-model="ruleForm.variations[props.$index].variationSku"
                                        placeholder="">

                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" label="申报价格(CNY)" width="120">
                                <template slot-scope="props">
                                    <el-input size="mini" v-model="ruleForm.variations[props.$index].supplyPrice"
                                        placeholder="">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="长*宽*高/mm">
                                <template slot-scope="props">
                                    <div style="display: flex;">
                                        <el-input size="mini"
                                            v-model="ruleForm.variations[props.$index].storeItem.packageLength"
                                            placeholder="">
                                        </el-input>
                                        <el-input size="mini"
                                            v-model="ruleForm.variations[props.$index].storeItem.packageWidth"
                                            placeholder="">
                                        </el-input>
                                        <el-input size="mini"
                                            v-model="ruleForm.variations[props.$index].storeItem.packageHeight"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="重量/mg">
                                <template slot-scope="props">
                                    <el-input size="mini" v-model="ruleForm.variations[props.$index].storeItem.weight"
                                        placeholder="">
                                    </el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>运输信息</span>
                </div>
                <el-form-item label="承诺发货时效：" prop="shipmentLimitSecond">
                    <el-radio v-model="ruleForm.shipmentLimitSecond" :label="86400">1个工作日内发货</el-radio>
                    <el-radio v-model="ruleForm.shipmentLimitSecond" :label="172800">2个工作日内发货</el-radio>
                    <el-radio v-model="ruleForm.shipmentLimitSecond" :label="259200"
                        v-if="ruleForm.personalizationSwitch == 1">3个工作日内发货</el-radio>
                </el-form-item>
                <el-form-item label="运费模板：" prop="freightTemplate">
                    <el-select v-model="ruleForm.freightTemplate" placeholder="请选择运费模板">
                        <el-option :label="item.templateName" :value="item.freightTemplateId"
                            v-for="(item, index) in freightTemplateOptions" :key="item.freightTemplateId"></el-option>
                    </el-select>
                </el-form-item>
            </el-card>
            <div class="btnBox">
                <el-button type="primary" @click="submitForm('ruleForm')">上架</el-button>
            </div>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :title="$t('other.a280')" :close-on-click-modal="false" :visible.sync="updatPic" width="30%">
            <div style="text-align: center">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :headers="token"
                    :http-request="handleUploadHttpRequest" :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只能上传jpg,png文件,且不超过2M</div>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updatPic = false, imageUrl = null, imageId = null">{{ $t('other.a106')
                }}</el-button>
                <el-button type="primary" @click="imgConfirm()">{{ $t('other.a279') }}</el-button>
            </span>
        </el-dialog>
        <el-dialog title="添加尺码表" :visible.sync="dialogVisibleSize" width="80%" :before-close="handleClose">
            <el-select v-model="templateSize" clearable placeholder="请选择引用模板">
                <el-option v-for="item in templateOptions" :key="item.businessId" :label="item.name"
                    :value="item.businessId">
                </el-option>
            </el-select>
            <div class="flex" style="margin-top: 20px;">
                模板名称：<el-input size="mini" placeholder="" v-model="sizeName">
                </el-input>
            </div>
            <el-table :data="sizeData" border style="width: 100%;margin-top: 20px;">
                <el-table-column prop="date" label="尺码" width="180">
                    <template slot-scope="props">
                        {{ props.row.values['1'] }}
                    </template>
                </el-table-column>
                <el-table-column prop="address" :label="item.name" v-for="(item, index) in sizeArr" :key="index">
                    <template slot-scope="props">
                        <el-input size="mini" placeholder="" v-model="props.row.values[item.id]">

                        </el-input>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleSize = false">取 消</el-button>
                <el-button type="primary" @click="closeSize">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="产品描述" :visible.sync="isProductDescribe" width="80%" :before-close="handleCloseP">
            <construct :productDescribe="productDescribe" :storeId="storeId" :classId="classId"></construct>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isProductDescribe = false">取 消</el-button>
                <el-button type="primary" @click="closeProductDescribe">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor';
import construct from '../../../components/construct.vue';
import draggable from "vuedraggable"
import galleryApi from '@/api/moudles/gallery'
import api from '@/api/api'
export default {
    name: 'publishTEMU',
    components: {
        quillEditor,
        draggable,
        construct
    },
    data() {
        return {
            isProductDescribe: false,
            dialogVisibleSize: false,
            token: {
                token: JSON.parse(localStorage.getItem('userInfo')).token
            },
            userId: JSON.parse(localStorage.getItem('userInfo')).userId,
            ruleForm: {
                // storeAccount: 634418219043305,
                // productClassify: [27011, 27012, 27031],
                storeAccount: '',
                productClassify: [],
                productAttribute: '',
                productTitle: '',
                productTitleEN: '',
                productCode: '',
                links: '',
                images: [],
                imagesOne: '',
                productDescribe: '',
                shipmentLimitSecond: '',
                freightTemplate: '',
                warehouseId: '',
                packageShape: '',
                packageType: '',
                personalizationSwitch: 0,
                sensitiveSwitch: 0,
                sensitiveType: [],
                productSkuSensitiveLimitReq: {
                    "maxBatteryCapacity": 0, //最大电池容量 (Wh)
                    "maxBatteryCapacityHp": 0, //最大电池容量 (mWh)
                    "maxLiquidCapacity": 0, //最大液体容量 (mL)
                    "maxLiquidCapacityHp": 0, //最大液体容量 (μL)
                    "maxKnifeLength": 0, //最大刀具长度 (mm)
                    "maxKnifeLengthHp": 0, //最大刀具长度 (μm)
                    "knifeTipAngle": {
                        "degrees": 0 //度数
                    } //刀尖角度
                },
                region1ShortName: 'CN',
                region2Id: '',
            },
            rules: {
                'storeAccount': [
                    { required: true, message: "请选择店铺账号", trigger: 'blur' },
                ],
                'productClassify': [
                    { required: true, message: "请选择产品分类", trigger: 'blur' },
                ],
                'productTitle': [
                    { required: true, message: "请输入产品标题", trigger: 'blur' },
                ],
                'productTitleEN': [
                    { required: true, message: "请输入英文标题", trigger: 'blur' },
                ],
                'shipmentLimitSecond': [
                    { required: true, message: "承诺发货时效", trigger: 'blur' },
                ],
                'freightTemplate': [
                    { required: true, message: "请选择运费模板", trigger: 'blur' },
                ],
                'region2Id': [
                    { required: true, message: "请选择产地", trigger: 'blur' },
                ],
                // 'warehouseId': [
                //     { required: true, message: "请选择仓库", trigger: 'blur' },
                // ],


            },
            storeAccountOptions: [],//店铺账户
            siteOptions: [],//经营站点
            productClassifyOptions: [],//产品分类
            properties: [],//产品属性
            freightTemplateOptions: [],//运费模板
            templateSize: '',
            templateOptions: [],//尺码表模板
            storeId: '',//店铺id
            shopSite: '',//站点
            options: [], // 初始选项数组
            loading: false, // 加载状态
            catId: '',
            classId: '',
            editorOption: {
                modules: {
                    syntax: {
                        highlight: text => hljs.highlightAuto(text).value
                    },
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                        ['blockquote'],

                        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                        [{ 'direction': 'rtl' }],                         // text direction

                        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                        // [{ 'font': [] }],
                        [{ 'align': [] }],
                        ['image']//去除video即可
                    ]
                },
                placeholder: '编辑内容'
            },
            fileList: [],
            fileListOne: [],
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            hideUpload: false,
            activeIndex: -1,
            activeOneIndex: -1,
            parentSpec: [],//父规格
            parentSpecActive1: null,
            parentSpecActive2: null,
            itemSpec1: [],
            itemSpec2: [],
            itemSpecChild1: [],
            itemSpecChild2: [],
            addSpecName1: "",
            addSpecName2: "",
            isStatus: false,
            sellerSKU: null,
            priceValue: null,
            stock: null,
            long: null,
            wide: null,
            tall: null,
            weight: null,
            changeAttrPic: false,
            updatPic: false,
            changePicObj: null,
            imageUrl: null,
            imageId: null,
            warehouse: [],
            warehouseName: [],
            warehouseOptions: [],
            maxlength: 250,
            sizeArr: [],
            groupList: [],
            sizeData: [],
            sizeName: "",
            productDescribe: [],
            propertiesChild: [],
        }
    },
    watch: {
        warehouse(newVal, oldVal) {
            console.log("=====1===")
            // 找出只在arr1中的元素
            const onlyInArr1 = newVal.filter(item => !oldVal.includes(item));
            // 找出只在arr2中的元素
            const onlyInArr2 = oldVal.filter(item => !newVal.includes(item));
            // console.log(this.ruleForm.variations)
            console.log(onlyInArr1)
            console.log(onlyInArr2)
            if (onlyInArr1.length > 0) {
                let idORname = onlyInArr1[0].split("+-+")
                let id = idORname[0]
                let name = idORname[1]
                this.ruleForm.variations.forEach(v => {
                    v.warehouseStockQuantityReqs.push({
                        "targetStockAvailable": v.stock, //sku目标库存值（覆盖写）
                        "warehouseId": id, //仓库ID
                    })
                })
                this.warehouseName.push({
                    "warehouseId": id, //仓库ID
                    "warehouseName": name //仓库名称
                })
            }

            if (onlyInArr2.length > 0) {
                let idORname = onlyInArr2[0].split("+-+")
                let id = idORname[0]
                let index = this.warehouseName.findIndex(item => item.warehouseId == id);
                this.warehouseName.splice(index, 1)
                this.ruleForm.variations.forEach(v => {
                    v.warehouseStockQuantityReqs.splice(index, 1)
                })
            }


        },
        productClassify(newVal, oldVal) {
            // maxlength
            if (newVal.includes()) {

            }
        },
        itemSpec2(newVal, oldVal) {
            if (this.isStatus) {
                let arr = []
                newVal.forEach((v, i) => {
                    arr.push({ "values": { "1": v.split('+-+')[1] } })
                    this.sizeArr.forEach((j, w) => {
                        arr[i].values[j.id] = "2"
                    })
                })
                console.log(arr)
                this.sizeData = arr
            } else {
                // this.ruleForm.variations
            }
        },
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        specsArr() {
            let arr = []
            if (this.itemSpec1.length > 0 && this.itemSpec2.length == 0) {
                this.itemSpec1.forEach(v => {
                    arr.push({
                        itemSpec1Value: v,
                        itemSpec2Value: '',
                    })
                })
            } else if (this.itemSpec2.length > 0 && this.itemSpec1.length == 0) {
                this.itemSpec2.forEach(j => {
                    arr.push({
                        itemSpec1Value: '',
                        itemSpec2Value: j,
                    })
                })
            } else if (this.itemSpec1.length > 0 && this.itemSpec2.length > 0) {
                this.itemSpec1.forEach(v => {
                    this.itemSpec2.forEach(j => {
                        arr.push({
                            itemSpec1Value: v,
                            itemSpec2Value: j,
                        })
                    })
                })
            }
            console.log(this.ruleForm.variations)
            console.log('44445555======')
            if (arr.length > this.ruleForm.variations.length) {
                for (let i = this.ruleForm.variations.length; i < arr.length; i++) {
                    this.ruleForm.variations.push({
                        "stock": 0,
                        "variationSku": "",
                        "image": "",
                        "storeItem": {
                            "packageHeight": 0,
                            "packageWidth": 0,
                            "packageLength": 0,
                            "weight": 0,
                        },
                        "supplyPrice": 8970,
                        "warehouseStockQuantityReqs": []
                    })
                }
            }
            return arr
        },
        cstews() {
            let ids = this.propertiesChild.map(v => {
                return v.parentTemplatePid
            })
            let arr = this.properties.filter(item => ids.includes(item.templatePid))
            let arrContent = []
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].propValue != '') {
                    arrContent.push(Number(arr[i].propValue.split("+-+")[0]))
                }
                if (arr[i].childrenBox.length > 0) {
                    for (let q = 0; q < arr[i].childrenBox.length; q++) {
                        if (arr[i].childrenBox[q].propValue != '') {
                            arrContent.push(Number(arr[i].childrenBox[q].propValue.split("+-+")[0]))
                        }
                    }
                }
            }
            for (let i = 0; i < this.properties.length; i++) {
                let v = this.properties[i]
                if (v.parentTemplatePid != 0&&v.templatePropertyValueParentList) {
                    v.isParentStatus = false
                    for (let j = 0; j < v.templatePropertyValueParentList.length; j++) {
                        if (arrContent.includes(v.templatePropertyValueParentList[j].parentVidList[0])) {
                            v.isParentStatus = true
                            v.values = v.valuesOld.filter(item => v.templatePropertyValueParentList[j].vidList.includes(item.vid))
                        }
                    }
                }
            }
            return ''
        }
    },
    created() {
        this.getGroupInfo()
    },
    mounted() {
        this.getSelData()


        // this.getFreightTemplate()
        // this.getParentSpec()
        // this.getWarehouseList()


        // this.getProductAttribute()
        // this.getSizecharts()
        // this.getSizechartsClass()
    },
    methods: {
        addAttribute(item) {
            console.log(item)
            if (item.childrenBox.length != item.values.length) {
                let obj = JSON.parse(JSON.stringify(item))
                obj.propValue = ""
                obj.numberInputValue = ""
                item.childrenBox.push(obj)
            }
        },
        OpenProductDescribe() {
            this.productDescribe = JSON.parse(JSON.stringify(this.ruleForm.productDescribe))
            this.isProductDescribe = true
        },
        closeProductDescribe() {
            let status = false
            this.productDescribe.forEach((v, i) => {
                v.priority = i
                if (v.type == 'image' && v.contentList[0].imgUrl != '') {
                    status = true
                }
            })
            if (!status) {
                this.$message.error('产品描述中至少需要包含一个图片模块，请添加后保存')
                return
            }
            this.ruleForm.productDescribe = JSON.parse(JSON.stringify(this.productDescribe))
            this.isProductDescribe = false
        },
        handleCloseP() {
            this.isProductDescribe = false
        },
        setEditStatus(e, index, childindex, status) {
            e.preventDefault()
            if (status == 'change') {
                this['itemSpecChild' + index][childindex].editStatus = !this['itemSpecChild' + index][childindex].editStatus
            } else if (status == 'close') {
                this['itemSpecChild' + index][childindex].editName = this['itemSpecChild' + index][childindex].name
                this['itemSpecChild' + index][childindex].editStatus = !this['itemSpecChild' + index][childindex].editStatus
            } else if (status == 'edit') {
                if (this['itemSpecChild' + index][childindex].editName.trim() == "") {
                    this['itemSpecChild' + index].splice(childindex, 1)
                    this['itemSpec' + index].splice(childindex, 1)
                } else {
                    this['itemSpecChild' + index][childindex].name = this['itemSpecChild' + index][childindex].editName
                    this['itemSpec' + index][childindex] = this['itemSpecChild' + index][childindex].editName
                }
                this['itemSpecChild' + index][childindex].editStatus = !this['itemSpecChild' + index][childindex].editStatus
            }
        },
        addSpec(index) {
            console.log(index)
            if (this['addSpecName' + index].trim() == "") {
                return
            }
            this['itemSpecChild' + index].push({
                name: this['addSpecName' + index].trim(),
                editName: this['addSpecName' + index].trim(),
                editStatus: false
            })
            this['itemSpec' + index].push(this['addSpecName' + index].trim())
            this['addSpecName' + index] = ""
            console.log(this['itemSpecChild' + index])
            console.log(this['itemSpec' + index])
            console.log(this['addSpecName' + index])
        },
        logImg() {
            console.log('999', this.ruleForm);
            let list = this.ruleForm.images
            for (let i = 0; i < list.length; i++) {
                list[i].positions = i
            }
            console.log('list', list);
        },
        getGroupInfo() {
            api
                .getStoreItemByGroupId({
                    groupId: this.$route.query.groupId
                })
                .then(res => {
                    console.log(res.data)
                    console.log("===1====")
                    if (res.code == 200) {
                        let list = res.data
                        list.storeItems.forEach(p => {
                            p.price = p.children.length > 0 ? p.children[0].price : 0
                            p.storeNum = p.children.length > 0 ? p.children[0].storeNum : 0
                            p.packageHeight = p.children.length > 0 ? p.children[0].packageHeight : 0
                            p.packageLength = p.children.length > 0 ? p.children[0].packageLength : 0
                            p.packageWidth = p.children.length > 0 ? p.children[0].packageWidth : 0
                            p.weight = p.children.length > 0 ? p.children[0].weight : 0
                            // p.chl_cusCode=p.children[0].cusCode //暂时不知道用处但报错所以先隐藏
                        })
                        console.log('i', list)
                        this.groupInfo = list
                        this.getModelInfo()
                    }
                })
        },
        //获取模版信息
        getModelInfo() {
            console.log(6666)
            api
                .getProductByproductId({
                    productId: this.$route.query.id
                }).then(res => {
                    if (res.code == 200) {
                        console.log('模版数据', res.data)
                        let that = this
                        let list = res.data
                        this.falg = false
                        list.drag = false
                        list.variations.forEach(p => {
                            let ttp = this.groupInfo.storeItems.find(item => item.cusCode == p.cusCode)
                            console.log(this.groupInfo.storeItems)
                            console.log(p.cusCode)
                            // that.falg= ttp ? false :true  stock
                            console.log('ttp', ttp);
                            p.imageId = ttp ? ttp.imageId : null
                            p.price = ttp ? ttp.children[0].price.toFixed(2) * 1000 : p.price * 1000
                            p.retailPrice = null
                            p.stock = ttp ? ttp.storeNum : p.stock
                            p.supplyPrice = p.price
                            console.log(p.supplyPrice)
                            // p.supplyPrice = ttp ? ttp.children[0].price.toFixed(2) :p.price
                            // p.supplyPrice = ttp ? ttp.price:null
                            // p.stock=ttp ? ttp.stock : p.stock
                            p.image = list.tiers[0].images[p.tierIndex[0]]
                            console.log(list.tiers[0].images)
                            let IMG = new Image();
                            IMG.src = list.tiers[0].images[p.tierIndex[0]];
                            IMG.onerror = () => {
                                console.log('=--=-=-=1==1-2=-2=-2=1-1=2')
                                p.image = 'https://img.kwcdn.com/product/open/159f8f614b154a4cbefa78631a830993-goods.jpeg'
                            }
                            p.warehouseStockQuantityReqs = []
                        })
                        if (that.falg) {
                            this.$message.warning(this.$t("other.a324"))
                        }
                        this.ruleForm = Object.assign({}, this.ruleForm, res.data)
                        console.log('-=-=-=-=-=-=')
                        console.log(this.ruleForm)
                        this.sizeChartImg = null
                        this.ruleForm.sizeChart = {
                            imgId: null
                        }
                        console.log('009', this.ruleForm);
                        this.ruleForm.productTitle = this.ruleForm.name
                        this.ruleForm.productTitleEN = this.ruleForm.name
                        this.ruleForm.images = this.ruleForm.images.map(item => item.image)
                        this.ruleForm.productDescribe = [{
                            "contentList": [
                                {
                                    "height": 62, //图片高度--通用，高度最小480px
                                    "text": this.ruleForm.description, //文字信息--文字模块，文本-text必填，长度限制500字符内
                                    "textModuleDetails": {
                                        "align": "left", //文字对齐方式，left--左对齐；right--右对齐；center--居中；justify--两端对齐文本-text必填
                                        "backgroundColor": "#FFFFFF", //背景颜色文本-text必填，六位值，例#ffffff
                                        "fontColor": "#333333", //文字颜色文本-text必填，六位值，例#333333
                                        "fontSize": 12 //文字模块字体大小文本-text必传12
                                    }, //文字模块详情文本-text必填
                                    "width": 750 //图片宽度--通用，宽度最小480px
                                }
                            ], //楼层内容
                            "floorId": null, //楼层id,null:新增,否则为更新
                            "key": "DecImage", //楼层类型的key,目前默认传'DecImage'
                            "lang": "en", //语言类型
                            "priority": 0, //楼层排序
                            "type": "text" //组件类型type,图片-image,文本-text
                        }]
                        this.productDescribe = JSON.parse(JSON.stringify(this.ruleForm.productDescribe))


                        this.ruleForm.imagesOne = this.ruleForm.images.length > 0 ? this.ruleForm.images[0] : []
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },
        getSelData() {
            this.getStoreAccount()

        },

        /* 生成规格
        */
        getCreateSpec(params) {
            var formData = new FormData()
            formData.append('shopId', this.storeId)
            formData.append('parentSpecId', params.parentSpecId)
            formData.append('specName', params.specName)
            return new Promise((resolve, reject) => {
                galleryApi
                    .createSpec(formData)
                    .then(res => {
                        if (res.errorCode === 1000000) {
                            let obj = {
                                "parentSpecId": Number(params.parentSpecId), //父规格id
                                "parentSpecName": params.parentSpecName, //父规格名称
                                "specId": Number(res.result.specId), //规格id
                                "specName": params.specName //子规格名称，限制的特殊字符枚举如下}
                            }
                            console.log(obj)
                            console.log("===1===")
                            resolve(obj)
                        } else {
                            reject(null)
                        }
                    })
            })
        },
        /**
 * 根据图片的url转换对应的base64值
 * @param { String } imageUrl 如：http://xxxx/xxx.png
 * @returns base64取值
 */
        urlToBase64(imageUrl, name) {
            let self = this
            return new Promise((resolve, reject) => {
                let canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                let img = new Image()
                img.crossOrigin = 'Anonymous' // 解决Canvas.toDataURL 图片跨域问题
                img.src = imageUrl
                img.onload = function () {
                    console.log(img.height)
                    canvas.height = img.height
                    canvas.width = img.width
                    ctx.fillStyle = '#fff' // canvas背景填充颜色默认为黑色
                    ctx.fillRect(0, 0, img.width, img.height)
                    ctx.drawImage(img, 0, 0) // 参数可自定义
                    const dataURL = canvas.toDataURL('image/jpeg', 1) // 获取Base64编码
                    // resolve(dataURL)
                    // self.uploadGoodsImage(dataURL)


                    let imageUrlSet = ''
                    if (dataURL.includes('data:image/jpeg;base64,')) {
                        imageUrlSet = dataURL.split('data:image/jpeg;base64,')[1]
                    }

                    if (dataURL.includes('data:image/png;base64,')) {
                        imageUrlSet = dataURL.split('data:image/png;base64,')[1]
                    }
                    let params = {
                        "shopId": self.storeId,
                        "image": imageUrlSet,
                        "imageBizType": 0,
                        "options": { "boost": "true", "cateId": Number(self.catId), "doIntelligenceCrop": "true", "sizeMode": self.isStatus && !name ? 2 : 0 }
                    }

                    galleryApi
                        .uploadGoodsImage(params)
                        .then(res => {
                            if (res.errorCode === 1000000) {
                                console.log("===1===")
                                resolve(self.isStatus && !name ? res.result.urls[0] : res.result.imageUrl)
                            } else {
                                reject(null)
                            }
                        })


                    canvas = null // 清除canvas元素
                    img = null // 清除img元素
                }
                img.onerror = function () {
                    reject(new Error('Could not load image at ' + imageUrl))
                }
            })
        },
        async submitForm(formName) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let cat = {}
            for (let i = 0; i < 10; i++) {
                cat[`cat${i + 1}Id`] = this.ruleForm.productClassify[i] ? this.ruleForm.productClassify[i] : 0
            }
            let data1AA = []
            this.properties.forEach(v => {
                if (v.controlType == 1 && v.chooseMaxNum > 1) {
                    v.propValue = v.propValueArr.join(',')
                } else if (v.controlType == 3 && v.chooseMaxNum > 1) {
                    v.propValue = v.propValueArr.join(',') + (v.propValue != '' ? (',' + v.propValue) : '')
                }
                if (v.isSale) {
                    if (v.name == '颜色') {
                        v.propValue = this.itemSpec1.join(',')
                    } else if (v.name == '尺寸') {
                        v.propValue = this.itemSpec2.join(',')
                    }
                }
                if (v.propValue && v.propValue != '') {
                    let status = v.propValue.includes('+-+')
                    let data11 = {
                        "templatePid": v.templatePid, //模板属性id
                        "pid": v.pid, //属性id
                        "refPid": v.refPid, //引用属性id
                        "propName": v.name, //引用属性名
                        "vid": status ? Number(v.propValue.split("+-+")[0]) : 0, //基础属性值id，没有的情况传0
                        "propValue": status ? v.propValue.split("+-+")[1] : '无', //基础属性值
                        "valueUnit": v.valueUnit ? v.valueUnit : '', //属性值单位，没有的情况传空字符串
                        "valueExtendInfo": v.valueExtendInfo, //属性扩展信息，attrs.get返回
                        "numberInputValue": v.numberInputValue ? Number(v.numberInputValue) : '' //属性输入值，例如：65.66
                    }
                    console.log(v)
                    console.log(data11)
                    console.log("==-=-=-=-=-=")
                    data1AA.push(data11)
                }

                if (v.childrenBox.length > 0) {
                    v.childrenBox.forEach(q => {
                        if (q.propValue && q.propValue != '' && !q.isSale) {
                            console.log(q.propValue)
                            let status = q.propValue.includes('+-+')
                            let data11 = {
                                "templatePid": q.templatePid, //模板属性id
                                "pid": q.pid, //属性id
                                "refPid": q.refPid, //引用属性id
                                "propName": q.name, //引用属性名
                                "vid": status ? Number(q.propValue.split("+-+")[0]) : 0, //基础属性值id，没有的情况传0
                                "propValue": status ? q.propValue.split("+-+")[1] : '无', //基础属性值
                                "valueUnit": q.valueUnit ? q.valueUnit : '', //属性值单位，没有的情况传空字符串
                                "valueExtendInfo": q.valueExtendInfo, //属性扩展信息，attrs.get返回
                                "numberInputValue": q.numberInputValue ? Number(q.numberInputValue) : '' //属性输入值，例如：65.66
                            }
                            // console.log(v)
                            // console.log(data11)
                            // console.log("==-=-=-=-=-=")
                            data1AA.push(data11)
                        }
                    })
                }
            })
            console.log(data1AA)
            console.log('===s=s=====s')
            let productSkuSpecReqs = []
            for (let i = 0; i < this.itemSpec1.length; i++) {
                if (this.isStatus) {
                    let params = {
                        parentSpecId: Number(this.parentSpecActive1.split('+-+')[0]),
                        parentSpecName: this.parentSpecActive1.split('+-+')[1],
                        specId: Number(this.itemSpec1[i].split('+-+')[0]),
                        specName: this.itemSpec1[i].split('+-+')[1],
                    }
                    productSkuSpecReqs.push(params)
                } else {
                    let params = {
                        parentSpecId: this.parentSpecActive1.split('+-+')[0],
                        parentSpecName: this.parentSpecActive1.split('+-+')[1],
                        specName: this.itemSpec1[i],
                    }
                    let obj = await this.getCreateSpec(params)
                    productSkuSpecReqs.push(obj)
                }
            }
            for (let i = 0; i < this.itemSpec2.length; i++) {
                if (this.isStatus) {
                    let params = {
                        parentSpecId: Number(this.parentSpecActive2.split('+-+')[0]),
                        parentSpecName: this.parentSpecActive2.split('+-+')[1],
                        specId: Number(this.itemSpec2[i].split('+-+')[0]),
                        specName: this.itemSpec2[i].split('+-+')[1],
                    }
                    productSkuSpecReqs.push(params)
                } else {
                    let params = {
                        parentSpecId: this.parentSpecActive2.split('+-+')[0],
                        parentSpecName: this.parentSpecActive2.split('+-+')[1],
                        specName: this.itemSpec2[i],
                    }
                    let obj = await this.getCreateSpec(params)
                    productSkuSpecReqs.push(obj)
                }
            }
            let imgBox = this.ruleForm.images
            let imgArr = []
            for (let i = 0; i < imgBox.length; i++) {
                let imgData = ''
                if (imgBox[i].includes("img.kwcdn.com")) {
                    imgData = imgBox[i]
                } else {
                    imgData = await this.urlToBase64(imgBox[i])
                    imgBox[i] = imgData
                }
                imgArr.push(imgData)
            }

            let productSkuReqs = []
            let targetRouteList = []
            // this.ruleForm.variations.forEach(v => {
            // for (let i = 0; i < this.ruleForm.variations.length; i++) {
            for (let i = 0; i < this.specsArr.length; i++) {
                // console.log(v)
                let v = this.ruleForm.variations[i]
                this.ruleForm.variations[i].image = this.isStatus ? imgArr[0] : (v.image.includes('img.kwcdn.com') ? v.image : await this.urlToBase64(v.image))
                productSkuReqs.push({
                    "thumbUrl": this.ruleForm.variations[i].image,//预览图
                    "extCode": v.variationSku, //sku货号，没有的场景传空字符串
                    "currencyType": "CNY",
                    "productSkuStockQuantityReq": {
                        "warehouseStockQuantityReqs": v.warehouseStockQuantityReqs //仓库存库存请求列表
                    }, //货品sku仓库库存，半托管发品必传
                    "productSkuSpecReqs": productSkuSpecReqs, //货品sku规格列表
                    "siteSupplierPrices": [
                        {
                            "siteId": 100, //申报价格站点id
                            "supplierPrice": Number(v.supplyPrice) //站点申报价格，单位 人民币：分，美元：美分
                        }
                    ], //站点供货价列表，半托必传
                    "productSkuWhExtAttrReq": {
                        "productSkuVolumeReq": {
                            "len": Number(v.storeItem.packageLength), //长，单位mm
                            "width": Number(v.storeItem.packageWidth), //宽，单位mm
                            "height": Number(v.storeItem.packageHeight) //高，单位mm
                        }, //货品sku体积
                        "productSkuWeightReq": {
                            "value": Number(v.storeItem.weight) //重量值，单位mg
                        }, //货品sku重量
                        "productSkuBarCodeReqs": [],
                        "productSkuSensitiveAttrReq": {
                            "isSensitive": this.ruleForm.sensitiveSwitch, //是否敏感属性，0：非敏感，1：敏感
                            "sensitiveList": this.ruleForm.sensitiveType //敏感类型，        PURE_ELECTRIC(110001, "纯电"),    INTERNAL_ELECTRIC(120001, "内电"),    MAGNETISM(130001, "磁性"),    LIQUID(140001, "液体"),    POWDER(150001, "粉末"),    PASTE(160001, "膏体"),    CUTTER(170001, "刀具")
                        }, //货品sku敏感属性请求
                        "productSkuSensitiveLimitReq": {
                            "maxBatteryCapacity": (this.ruleForm.sensitiveType.includes(110001) || this.ruleForm.sensitiveType.includes(120001)) ? this.ruleForm.productSkuSensitiveLimitReq.maxBatteryCapacity : null, //最大电池容量 (Wh)
                            "maxBatteryCapacityHp": (this.ruleForm.sensitiveType.includes(110001) || this.ruleForm.sensitiveType.includes(120001)) ? this.ruleForm.productSkuSensitiveLimitReq.maxBatteryCapacity * 1000 : null, //最大电池容量 (mWh)
                            "maxLiquidCapacity": this.ruleForm.sensitiveType.includes(140001) ? this.ruleForm.productSkuSensitiveLimitReq.maxLiquidCapacity : null, //最大液体容量 (mL)
                            "maxLiquidCapacityHp": this.ruleForm.sensitiveType.includes(140001) ? this.ruleForm.productSkuSensitiveLimitReq.maxLiquidCapacity * 1000 : null, //最大液体容量 (μL)
                            "maxKnifeLength": this.ruleForm.sensitiveType.includes(170001) ? this.ruleForm.productSkuSensitiveLimitReq.maxKnifeLength : null, //最大刀具长度 (mm)
                            "maxKnifeLengthHp": this.ruleForm.sensitiveType.includes(170001) ? this.ruleForm.productSkuSensitiveLimitReq.maxKnifeLength * 1000 : null, //最大刀具长度 (μm)
                            "knifeTipAngle": this.ruleForm.sensitiveType.includes(170001) ? {
                                "degrees": this.ruleForm.productSkuSensitiveLimitReq.knifeTipAngle.degrees //度数
                            } : null //刀尖角度
                        } //货品sku敏感属性限制请求
                    }
                })
                if (i == 0) {
                    v.warehouseStockQuantityReqs.forEach(j => {
                        targetRouteList.push({
                            "siteIdList": [100],
                            "warehouseId": j.warehouseId
                        })
                    })
                }
            }
            // })
            this.ruleForm.imagesOne = this.ruleForm.imagesOne.includes('img.kwcdn.com') ? this.ruleForm.imagesOne : await this.urlToBase64(this.ruleForm.imagesOne, 'materialImgUrl')
            let data = {
                "shopId": this.ruleForm.storeAccount.split('+-+')[0] + '',
                "productName": this.ruleForm.productTitle,
                // "cat1Id": 27011, "cat2Id": 30327, "cat3Id": 30480, "cat4Id": 30486, "cat5Id": 0, "cat6Id": 0, "cat7Id": 0, "cat8Id": 0, "cat9Id": 0, "cat10Id": 0,
                "semiLanguageStrategy": 2,
                "personalizationSwitch": this.ruleForm.personalizationSwitch,
                "materialImgUrl": this.ruleForm.imagesOne,
                "productI18nReqs": [{ "language": "en", "productName": this.ruleForm.productTitleEN }],
                // "productWarehouseRouteReq": { "targetRouteList": [{ "siteIdList": [100], "warehouseId": this.ruleForm.warehouseId }] },
                "productWarehouseRouteReq": { "targetRouteList": targetRouteList },
                "productPropertyReqs": data1AA,
                "productSkcReqs": [
                    {
                        "previewImgUrls": imgArr,
                        "extCode": "",
                        "mainProductSkuSpecReqs": [{ "parentSpecId": 0, "parentSpecName": "", "specId": 0, "specName": "" }],
                        "productSkuReqs": productSkuReqs
                    }],
                "productSpecPropertyReqs": [],
                "sizeTemplateIds": [],
                "carouselImageUrls": imgArr,
                "goodsLayerDecorationReqs": this.ruleForm.productDescribe,
                "showSizeTemplateIds": [],
                "productWhExtAttrReq": { "outerGoodsUrl": "", "productOrigin": { "region1ShortName": "CN", "region2Id": this.ruleForm.region2Id } }, "productOuterPackageReq": { "packageShape": this.ruleForm.packageShape, "packageType": this.ruleForm.packageType },
                "productShipmentReq": { "freightTemplateId": this.ruleForm.freightTemplate, "shipmentLimitSecond": this.ruleForm.shipmentLimitSecond },
                "productSemiManagedReq": { "bindSiteIds": [100] },
                "productOuterPackageImageReqs": []
            }
            let fullDetails = Object.assign({}, data, cat);

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    galleryApi
                        .addGoods(fullDetails)
                        .then(res => {
                            loading.close();
                            if (res.errorCode === 1000000) {
                                this.$message.success('成功')
                                console.log("===78787878===")
                            } else {
                                this.$message.error(res.errorMsg)
                            }
                        })
                } else {
                    loading.close();
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleChange(name, e) {
            console.log(name)
            console.log(e)
            if (name == 'storeAccount') {
                this.storeId = e.split('+-+')[0]
                this.shopSite = e.split('+-+')[1] == '0' ? 100 : e.split('+-+')[1]
                // this.productClassifyShow = false
                // this.productClassifyShow = true
                this.options = []
                this.getFreightTemplate()
                this.getParentSpec()
                this.getWarehouseList()
            } else if (name == 'productClassify') {
                console.log(e)
                this.isStatus = this.$refs['nodeName'].getCheckedNodes()[0].data.catType == 1 ? true : false
                this.catId = e[e.length - 1]
                this.getProductAttribute()
                this.getSizecharts()
                this.getSizechartsClass()
            }
        },
        getStoreAccount() {
            var formData = new FormData()
            formData.append('userId', this.userId)
            formData.append('platform', "TEMU")
            galleryApi
                .selectAllTemuShop(formData)
                .then(res => {
                    console.log(res)
                    console.log("=4=4==4=4==4")
                    if (res.code === 200) {
                        this.storeAccountOptions = res.data
                    }
                })
        },
        getProductAttribute() {
            var formData = new FormData()
            formData.append('shopId', this.storeId)
            formData.append('catId', this.catId)
            galleryApi
                .getAttrs(formData)
                .then(res => {
                    console.log(res)
                    console.log('===11221===')
                    //isSale
                    if (res.errorCode === 1000000) {
                        let arr = []

                        for (let i = 0; i < res.result.properties.length; i++) {
                            let v = res.result.properties[i]
                            v.childrenBox = []
                            // res.result.properties.forEach((v, i) => {
                            v.propValue = v.propValue ? v.propValue : ''
                            v.propValueArr = []
                            v.valueUnit = v.valueUnit ? v.valueUnit[0] : ''
                            v.valueExtendInfo = v.valueExtendInfo ? v.valueExtendInfo : ''
                            v.numberInputValue = v.numberInputValue ? v.numberInputValue : ''
                            if (v.isSale) {
                                console.log(v)
                                console.log("===3==3==3=3====3===3")
                                if (v.name == '颜色') {

                                    this.parentSpecActive1 = v.parentSpecId + '+-+' + v.name
                                    this.itemSpec1 = []
                                    this.itemSpecChild1 = []
                                    v.values.forEach(j => {
                                        this.itemSpecChild1.push(j)
                                    })
                                }

                                if (v.name == '尺码') {
                                    this.parentSpecActive2 = v.parentSpecId + '+-+' + v.name
                                    this.itemSpec2 = []
                                    this.itemSpecChild2 = []
                                    v.values.forEach(j => {
                                        this.itemSpecChild2.push(j)
                                    })
                                }
                            }
                            if (v.parentTemplatePid != 0) {
                                v.isParentStatus = false
                                v.valuesOld = v.values
                                arr.push(v)
                            } else {
                                v.isParentStatus = true
                            }
                        }
                        // })
                        console.log(arr)
                        console.log("====2===3==")
                        // this.ruleForm.pddkjAttribute.attribute = arr
                        this.propertiesChild = arr
                        this.properties = res.result.properties
                        console.log(this.properties)

                    }
                })
        },
        getParentSpec() {
            var formData = new FormData()
            formData.append('shopId', this.storeId)
            galleryApi
                .getParentSpec(formData)
                .then(res => {
                    console.log(res)
                    console.log('===222===')
                    if (res.errorCode === 1000000) {
                        this.parentSpec = res.result.parentSpecDTOS
                        this.parentSpecActive1 = this.parentSpec[0].parentSpecId + '+-+' + this.parentSpec[0].parentSpecName
                        this.parentSpecActive2 = this.parentSpec[1].parentSpecId + '+-+' + this.parentSpec[1].parentSpecName
                    }
                })
        },
        async fetchData(node, resolve) {
            this.loading = true; // 开始加载
            const { level, value } = node; // 获取当前节点的层级和值
            let data;
            if (level === 0) { // 如果是第一级，则加载第一级数据
                data = await this.fetchFirstLevelData(); // 假设的方法来获取第一级数据
            } else { // 如果是后续级，根据父级值加载数据
                data = await this.fetchSubLevelData(value); // 假设的方法来获取子级数据，value是父级的值
            }
            resolve(data); // 解析数据，更新节点显示
            this.loading = false; // 结束加载
        },
        fetchFirstLevelData() {
            // 模拟异步获取第一级数据
            return new Promise(resolve => {
                let data = {
                    "shopId": this.storeId, //店铺ID
                    "siteId": 1, //站点id ，当前固定传1
                    "parentCatId": 0, //父类目id，为0表示查一级类目列表 
                    "showHidden": "false" //是否展示隐藏类目，默认不展示
                }
                galleryApi
                    .getCats(data)
                    .then(res => {
                        if (res.errorCode === 1000000) {
                            const map = res.result.categoryDTOList.map(v => {
                                return { value: v.catId, label: v.catName, catType: v.catType, isLeaf: v.isLeaf }
                            });
                            resolve(map);
                        }
                    })
            });
        },
        fetchSubLevelData(parentValue) {
            // 模拟异步获取子级数据，根据parentValue来决定加载哪一级的数据
            return new Promise(resolve => {
                let data = {
                    "shopId": this.storeId, //店铺ID
                    "siteId": 1, //站点id ，当前固定传1
                    "parentCatId": parentValue, //父类目id，为0表示查一级类目列表 
                    "showHidden": "false" //是否展示隐藏类目，默认不展示
                }
                galleryApi
                    .getCats(data)
                    .then(res => {
                        if (res.errorCode === 1000000) {
                            if (res.result.categoryDTOList.length == 0) {
                                resolve([]);// 没有更多子级时返回空数组
                            } else {
                                const map = res.result.categoryDTOList.map(v => {
                                    return { value: v.catId, label: v.catName, catType: v.catType, leaf: v.isLeaf }
                                });
                                resolve(map);
                            }
                        }
                    })
            });
        },
        getFreightTemplate() {
            let data = {
                "shopId": this.storeId, //店铺ID
                "siteIdList": [
                    this.shopSite
                ] //站点ID列表
            }
            galleryApi
                .getLogisticsTemplate(data)
                .then(res => {
                    console.log(res)
                    console.log("===1===")
                    if (res.errorCode === 1000000) {
                        this.freightTemplateOptions = res.result.freightTemplates
                    }
                })
        },
        getWarehouseList() {
            let data = {
                "shopId": this.storeId, //店铺ID
                "siteIdList": [
                    this.shopSite
                ] //站点ID列表
            }
            galleryApi
                .getWarehouseList(data)
                .then(res => {
                    console.log(res)
                    console.log("===1789===")
                    if (res.errorCode === 1000000) {
                        this.warehouseOptions = res.result.warehouseDTOList[0].validWarehouseList
                    }
                })
        },
        getSizecharts() {
            var formData = new FormData()
            formData.append('shopId', this.storeId)
            formData.append('offset', 1)
            formData.append('pageSize', 100)
            formData.append('catId', this.catId)
            galleryApi
                .getSizecharts(formData)
                .then(res => {
                    console.log(res)
                    console.log("===189===")
                    if (res.errorCode === 1000000) {
                        this.templateOptions = res.result.sizeSpecDataList
                    }
                })
        },
        getSizechartsClass() {
            var formData = new FormData()
            formData.append('shopId', this.storeId)
            formData.append('catId', this.catId)
            galleryApi
                .getSizechartsClass(formData)
                .then(res => {
                    console.log(res)
                    console.log("===178888889===")
                    if (res.errorCode === 1000000) {
                        // this.templateOptions = res.result.sizeSpecDataList
                        this.getSizechartsSettings()
                        this.getSizeChartsMeta(res.result.sizeSpecClassCat.classType, res.result.sizeSpecClassCat.classId, res.result.sizeSpecClassCat.relatedClassIds)
                    }
                })
        },
        getSizeChartsMeta(classType, classId, relatedClassIds) {
            var formData = new FormData()
            formData.append('shopId', this.storeId)
            if (classType != 1) {
                formData.append('catId', this.catId)
                formData.append('classId', classId)
                this.classId = classId
            } else {
                formData.append('catId', this.catId)
                formData.append('classId', relatedClassIds.join(','))
                this.classId = relatedClassIds.join(',')
            }
            // formData.append('catId', this.catId)

            // formData.append('classId', classId)
            galleryApi
                .getSizeChartsMeta(formData)
                .then(res => {
                    console.log(res)
                    console.log("===9999888889===")
                    if (res.errorCode === 1000000) {
                        this.sizeArr = res.result.sizeSpecMeta.elementList
                        this.groupList = res.result.sizeSpecMeta.groupList
                    }
                })
        },
        getSizechartsSettings() {
            var formData = new FormData()
            formData.append('shopId', this.storeId)
            formData.append('catId', this.catId)
            galleryApi
                .getSizechartsSettings(formData)
                .then(res => {
                    console.log(res)
                    console.log("===444488889===")
                    if (res.errorCode === 1000000) {
                        // this.templateOptions = res.result.sizeSpecDataList
                    }
                })
        },
        convert(name) {
            this.ruleForm[name] = this.ruleForm[name].charAt(0).toUpperCase() + this.ruleForm[name].substring(1);
        },
        verify(name) {
            this.ruleForm[name] = this.ruleForm[name].replace(/[^a-zA-Z0-9\s，。？！：“”‘’《》【】（）]/g, '');
        },
        getBase64(file) {
            return new Promise(function (resolve, reject) {
                let reader = new FileReader();
                let imgResult = "";
                reader.readAsDataURL(file);
                reader.onload = function () {
                    imgResult = reader.result;
                };
                reader.onerror = function (error) {
                    reject(error);
                };
                reader.onloadend = function () {
                    resolve(imgResult);
                };
            });
        },
        handlePreview(file) {
            this.ruleForm.images.push({
                image: file.data,
                itemId: null,
                positions: this.ruleForm.images.length,
                productId: this.ruleForm.productId
            })
        },
        handleExceed(files, fileList) {
            this.$message.warning("产品轮播图最多不能超过10张图");
        },

        imgConfirm() {
            console.log(this.changePicObj)
            console.log(this.imageUrl)
            console.log(this.ruleForm)
            let ttp = this.ruleForm.variations[this.changePicObj]
            ttp.image = this.imageUrl
            ttp.imageId = this.imageId
            this.$set(this.ruleForm.variations, this.changePicObj, ttp)
            console.log(this.ruleForm.variations)
            this.updatPic = false
            this.changeAttrPic = false

        },
        closeSize() {
            let data = {
                "shopId": this.storeId,
                "catId": Number(this.catId),
                "classId": this.classId,
                "name": this.sizeName,
                "operatorId": 0,
                "operatorName": "0",
                "operatorType": 0,
                "reusable": false,
                "content": {
                    "generalSizeType": 1, "localSizeSource": 1,
                    "meta": {
                        "elementList": this.sizeArr,
                        "groupList": this.groupList,
                    },
                    "records": this.sizeData
                }
            }
            galleryApi
                .createSizecharts(data)
                .then(res => {
                    console.log(res)
                    console.log("===444488889===")
                    if (res.errorCode === 1000000) {
                        // this.templateOptions = res.result.sizeSpecDataList
                        this.businessId = res.result.businessId
                        this.dialogVisibleSize = false
                    } else {
                        this.$message.error(res.errorMsg)
                    }
                })
        },
        openSize() {
            this.dialogVisibleSize = true
        },
        handleClose() {
            this.dialogVisibleSize = false
        },
        setText(arr) {
            let setArr = []
            arr.forEach(v => {
                setArr.push(v.split('+-+')[1])
            })
            return setArr.join(',')
        },
        changePic(item, index) {
            this.changeAttrPic = true
            console.log(item, index)
            this.updatPic = true
            this.changePicObj = item.tierIndex[0]
        },
        massSetVariation() {
            this.ruleForm.variations.forEach((p, index) => {
                p.variationSku = this.sellerSKU ? this.sellerSKU : p.variationSku
                p.retailPrice = this.priceValue ? this.priceValue : p.retailPrice
                p.price = this.priceValue ? this.priceValue : p.price
                p.stock = this.stock ? this.stock : p.stock
                p.supplyPrice = this.priceValue ? this.priceValue : p.supplyPrice
                p.storeItem.packageLength = this.long ? this.long : p.storeItem.packageLength
                p.storeItem.packageWidth = this.long ? this.wide : p.storeItem.packageWidth
                p.storeItem.packageHeight = this.long ? this.tall : p.storeItem.packageHeight
                p.storeItem.weight = this.long ? this.weight : p.storeItem.weight
                this.$set(this.ruleForm.variations, index, p)
            })
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('请上传JPG、PNG格式照片!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        uploadTEMU(e) {
            console.log(e)
            console.log("===-===")
            let file = e.file;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // console.log(reader.result); // base64
                let imageUrlSet = ''
                if (reader.result.includes('data:image/jpeg;base64,')) {
                    imageUrlSet = reader.result.split('data:image/jpeg;base64,')[1]
                }

                if (reader.result.includes('data:image/png;base64,')) {
                    imageUrlSet = reader.result.split('data:image/png;base64,')[1]
                }
                let params = {
                    "shopId": this.storeId,
                    "image": imageUrlSet,
                    "imageBizType": 0,
                    "options": { "boost": "true", "cateId": Number(this.catId), "doIntelligenceCrop": "true", "sizeMode": this.isStatus ? 2 : 0 }
                }

                galleryApi
                    .uploadGoodsImage(params)
                    .then(res => {
                        if (res.errorCode === 1000000) {
                            console.log("===1===")
                            this.ruleForm.images.push(this.isStatus ? res.result.urls[0] : res.result.imageUrl)
                            // resolve(self.isStatus ? res.result.urls[0] : res.result.imageUrl)
                        } else {
                            this.$message.error(res.errorMsg)
                            // reject(null)
                        }
                    })
            }
            reader.onerror = function (err) {
                console.log(err);
            }
        },
        uploadTEMUOne(e) {
            console.log(e)
            console.log("===-===")
            let file = e.file;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // console.log(reader.result); // base64
                let imageUrlSet = ''
                if (reader.result.includes('data:image/jpeg;base64,')) {
                    imageUrlSet = reader.result.split('data:image/jpeg;base64,')[1]
                }

                if (reader.result.includes('data:image/png;base64,')) {
                    imageUrlSet = reader.result.split('data:image/png;base64,')[1]
                }
                let params = {
                    "shopId": this.storeId,
                    "image": imageUrlSet,
                    "imageBizType": 0,
                    "options": { "boost": "true", "cateId": Number(this.catId), "doIntelligenceCrop": "true", "sizeMode": 0 }
                }

                galleryApi
                    .uploadGoodsImage(params)
                    .then(res => {
                        if (res.errorCode === 1000000) {
                            console.log("===1===")
                            this.ruleForm.imagesOne = res.result.imageUrl
                            // resolve(self.isStatus ? res.result.urls[0] : res.result.imageUrl)

                        } else {
                            this.$message.error(res.errorMsg)
                            // reject(null)
                        }
                    })
            }
            reader.onerror = function (err) {
                console.log(err);
            }
        },
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('请上传JPG、PNG格式照片!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        handleUploadHttpRequest(e) {
            console.log(e)
            console.log("===-===")
            let file = e.file;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // console.log(reader.result); // base64
                let imageUrlSet = ''
                if (reader.result.includes('data:image/jpeg;base64,')) {
                    imageUrlSet = reader.result.split('data:image/jpeg;base64,')[1]
                }

                if (reader.result.includes('data:image/png;base64,')) {
                    imageUrlSet = reader.result.split('data:image/png;base64,')[1]
                }
                let params = {
                    "shopId": this.storeId,
                    "image": imageUrlSet,
                    "imageBizType": 0,
                    "options": { "boost": "true", "cateId": Number(this.catId), "doIntelligenceCrop": "true", "sizeMode": this.isStatus ? 2 : 0 }
                }

                galleryApi
                    .uploadGoodsImage(params)
                    .then(res => {
                        if (res.errorCode === 1000000) {
                            console.log("===1===")
                            this.imageUrl = this.isStatus ? res.result.urls[0] : res.result.imageUrl
                            // resolve(self.isStatus ? res.result.urls[0] : res.result.imageUrl)

                        } else {
                            this.$message.error(res.errorMsg)
                            // reject(null)
                        }
                    })
            }
        },
    }



}
</script>
  
  
<style lang="scss" scope>
.publishTEMU {
    padding: 20px;

    .box-card {
        margin-bottom: 20px;
    }

    .productAttribute {
        background-color: #f6f6f5;
        padding: 20px;
    }
}

.flex {
    display: flex;
}

.smallTips {
    margin-left: 10px;
    font-size: 14px;
    color: #999;
}

.editorBox {
    .el-form-item__content {
        line-height: normal;
    }

    padding-bottom: 20px;
}

.btnBox {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0px;
}

.hide .el-upload--picture-card {
    display: none;
}



.imgBox {
    width: 96px;
    height: 96px;
    border: 1px dashed #dbdbdb;
    position: relative;
    top: 21px;
    left: 10px;
    margin: 1px 1px;
    cursor: pointer;
    overflow: hidden;
    position: relative;

    .pomjg {
        text-align: center;
        margin-top: 30px;
    }

    .delBox {
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .ingk {
            display: flex;
            justify-content: space-around;
            padding-bottom: 10px;

            .el-icon-edit {
                padding: 0 5px;
            }
        }
    }
}

.delBoxTe {
    .delBox {
        display: none;
    }
}

.delBoxTe:hover {
    .delBox {
        display: flex;
    }
}

.checkSpecBox {
    margin-bottom: 10px;

    .checkSpecRight {
        margin-left: 10px;
        max-width: 90%;

        .addSpec {
            min-height: 50px;
        }

        .el-checkbox {
            margin-bottom: 10px;
        }
    }
}

.tgrf {
    padding: 5px 15px;
}

.qbrt {
    padding: 6px 15px;

    input {
        border: none;
    }
}

.ppol {
    background-color: #f7f8fa;
}

.bghd {
    font-size: 14px;
    padding: 2px 5px;
}

.ilnrg {
    display: flex;
    flex-wrap: wrap;
    width: 973px;
    justify-content: space-between;

    .ijgn {
        font-size: 14px;
        padding-bottom: 5px;
    }

    .yhgt {
        display: flex;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 2px 15px;

        .yjbg {
            margin-right: 93px;
        }
    }

    .kong {
        border: 1px solid #eee;
        display: inline-block;
        width: 80px;
    }

    .ogong {
        width: 255px;
        margin-bottom: 8px;

        .olik {
            font-size: 12px;
            margin-bottom: 2px;
        }
    }
}

.iyubn {
    position: relative;

    .ingknv {
        position: absolute;
        top: 5px;
        right: 10px;
        font-size: 12px;
    }
}

.ImgPox {
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 2px;
    border: 1px dashed #eee;
    cursor: pointer;

    img {
        width: 100%;
    }
}

.attImg {
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 2px;
    border: 1px dashed #eee;
    cursor: pointer;
}

.attImg::before {
    content: '+';
    position: relative;
    top: 7px;
    left: 12px;
    font-size: 20px;
    color: #eee;
}

.ikrn::before {
    margin-right: 4px;
    content: "*";
    color: #e64a4a;
}

.baseInfo {
    border: 1px solid #eee;
    margin-top: 20px;

    .bugkn {
        display: flex;
        justify-content: space-between;
        padding: 0 10px 10px 116px;
        font-size: 16px;
        color: #757575;
        font-weight: 600;
    }

    .title {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.8);
        padding: 17px 15px;
        font-weight: bold;
    }

    .supplice {
        position: absolute;
        top: 12.5px;
        right: 11px;
    }

    .gong {
        background-color: #f5f5f5;
        padding: 1px 5px;
        display: inline-block;
        width: 78px;
    }

    .refd {
        padding: 15px 0;
    }

    .yhjv {
        margin: 10px;
        background-color: #fff;
        box-sizing: border-box;
        padding: 5px 10px;

        .gtyh {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .ppolk {
            display: flex;
            margin-top: 10px;
        }
    }

    .leftTesc {
        display: flex;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        padding-left: 20px;
        margin-bottom: 40px;

        .tgrf {
            padding: 5px 15px;
        }

        .qbrt {
            padding: 6px 15px;

            input {
                border: none;
            }
        }

        .ppol {
            background-color: #f7f8fa;
        }

        .bghd {
            font-size: 14px;
            padding: 2px 5px;
        }

        .ilnrg {
            display: flex;
            flex-wrap: wrap;
            width: 973px;
            justify-content: space-between;

            .ijgn {
                font-size: 14px;
                padding-bottom: 5px;
            }

            .yhgt {
                display: flex;
                margin-top: 10px;
                box-sizing: border-box;
                padding: 2px 15px;

                .yjbg {
                    margin-right: 93px;
                }
            }

            .kong {
                border: 1px solid #eee;
                display: inline-block;
                width: 80px;
            }

            .ogong {
                width: 255px;
                margin-bottom: 8px;

                .olik {
                    font-size: 12px;
                    margin-bottom: 2px;
                }
            }
        }

        .inrk {
            padding-right: 20px;
        }

        .imgBox {
            width: 96px;
            height: 96px;
            border: 1px dashed #dbdbdb;
            position: relative;
            top: 21px;
            left: 10px;
            margin: 1px 1px;
            cursor: pointer;
            overflow: hidden;
            position: relative;

            .pomjg {
                text-align: center;
                margin-top: 30px;
            }

            .delBox {
                width: 100%;
                height: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                text-align: center;
                background-color: rgba(0, 0, 0, 0.5);
                color: #fff;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;

                .ingk {
                    display: flex;
                    justify-content: space-around;
                    padding-bottom: 10px;

                    .el-icon-edit {
                        padding: 0 5px;
                    }
                }
            }
        }

        .delBoxTe {
            .delBox {
                display: none;
            }
        }

        .delBoxTe:hover {
            .delBox {
                display: flex;
            }
        }
    }
}

.mainContent {
    display: flex;
}

.lefttips {
    width: 150px;
    box-sizing: border-box;
    padding: 5px;

    .sigk {
        margin-top: 250px;
        box-sizing: border-box;
        padding: 10px 10px;
        box-shadow: 0 0 8px 0 #f3f3f3;
        position: fixed;
        width: 139px;

        .jgind {
            background-color: #ff7300;
            text-align: center;
            padding: 5px 0;
            color: #fff;
        }

        .kloi {
            padding: 2px 0;
        }
    }
}

.right_content {
    flex: 1;
    margin-bottom: 150px;
}

.desctext {
    font-size: 20px;
    color: #757575;
    padding: 10px 0;
}

.categoryDesc {
    background-color: #f7f8fa;
    margin-top: 20px;
    padding: 10px;
}

.categoryname {
    margin: 0 5px;

    .inkg {
        padding: 0 5px;
    }
}


.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px solid #000;
    border-radius: 5px;
}

.ilnrg {
    width: 100%;
}

.DivHover:hover {
    .DivHoverItem {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
    }
}
</style>
  